<!-- Loader -->
<div *ngIf="loader">
    <div id="global-loader">
        <img src="../../assets/img/loader.svg" class="loader-img" alt="Loader">
    </div>
</div>
<!-- End Loader -->